export default {
    root: {
        select: '#fff'
    }
};  